import { usePageOptions } from '@app/utils/hooks/pages/usePageOptions';
import { useTranslation } from 'react-i18next';

import { Cms, Id } from '../../../../typings';
import { Button } from '../various/Button';
import { Dropdown, DropdownMenu, DropdownTrigger } from '../various/Dropdown';
import { MoreVerticallySmall } from '../various/Icons';

interface Props {
  page: Cms.Page;
  setEditingPage: (id: Id) => void;
  openSharePage: (id: Id) => void;
  duplicatePage: ({ pageId }: { pageId: Id }) => void;
}

export const PageOptionsDropdown = ({ page, setEditingPage, openSharePage, duplicatePage }: Props) => {
  const { t } = useTranslation(['confirmationConfig', 'common', 'cms']);
  const pageOptions = usePageOptions({ duplicatePage, openSharePage, page, setEditingPage });

  return (
    <Dropdown title={t('cms:page_options')}>
      <DropdownTrigger>
        <Button aria-label={t('cms:page_options')} variant="text" color="secondary" icon={MoreVerticallySmall} />
      </DropdownTrigger>
      <DropdownMenu items={pageOptions} />
    </Dropdown>
  );
};
